import React, { useEffect, useState } from "react";
import { NavLink, useLocation, useNavigate } from "react-router-dom";
import styled from "styled-components";

import IcoMore from "../../styles/images/more.svg";
import { useDispatch, useSelector } from "react-redux";
import { getToken } from "../hooks/authFunc";
import { mainActions } from "../../store/slices/mainSlice";
import { checkMobile } from "../hooks/basicFunc";
import { Modal } from "../modal/Modal";
import useDidMountEffect from "../hooks/useDidMountEffect";

const AffiliateIconsAllList = (props) => {
  const { data } = props;
  const navigate = useNavigate();
  const location = useLocation();
  const dispatch = useDispatch();
  const modalMsg = useSelector((state) => state.main.modalMsg);
  const [openModal, setOpenModal] = useState(false);

  const groupByCategory = (dataArray) => {
    const groupedData = {};

    dataArray.forEach((item) => {
      const category = item.category;

      if (!groupedData[category]) {
        groupedData[category] = [];
      }

      groupedData[category].push(item);
    });

    return groupedData;
  };

  const dataByCategory = groupByCategory(data.list);

  const userAgent = checkMobile();

  // const handleInstallApp = (li) => {
  //   if (userAgent == "ios") {
  //     li.ios
  //       ? window.open(li.ios)
  //       : dispatch(
  //           mainActions.showMsg({
  //             msg: `준비중입니다.`,
  //             type: "",
  //           })
  //         );
  //   } else if (userAgent == "android") {
  //     li.aos
  //       ? window.open(li.aos)
  //       : dispatch(
  //           mainActions.showMsg({
  //             msg: `준비중입니다.`,
  //             type: "",
  //           })
  //         );
  //   } else {
  //     li.web
  //       ? window.open(li.web)
  //       : dispatch(
  //           mainActions.showMsg({
  //             msg: `준비중입니다.`,
  //             type: "",
  //           })
  //         );
  //   }
  // };

  const redirectStore = (li) => {
    //딥링크 없는 경우 로직
    if (userAgent == "other") {
      li.web
        ? window.open(li.web)
        : dispatch(
            mainActions.showMsg({
              msg: `준비중입니다.`,
              type: "",
            })
          );
    } else if (window.confirm("스토어로 이동하시겠습니까?")) {
      if (userAgent == "ios") {
        li.ios
          ? window.open(li.ios)
          : dispatch(
              mainActions.showMsg({
                msg: `준비중입니다.`,
                type: "",
              })
            );
      } else if (userAgent == "android") {
        li.aos
          ? window.open(li.aos)
          : dispatch(
              mainActions.showMsg({
                msg: `준비중입니다.`,
                type: "",
              })
            );
      } else {
        li.web
          ? window.open(li.web)
          : dispatch(
              mainActions.showMsg({
                msg: `준비중입니다.`,
                type: "",
              })
            );
      }
    }
  };
  function exeDeepLink(li) {
    let url = li?.scheme;
    if (url) {
      // let url = "twitter://";
      //if :// 가 있으면 제거하기
      // let url = "kakaomap";
      if (url.includes("://")) {
        url = url.replace("://", "");
      }
      if (window.ReactNativeWebView) {
        const message = { type: "openUrl", content: `${url}` };
        window.ReactNativeWebView.postMessage(JSON.stringify(message));
      }
      window.location.href = `${url}://`;
    }
  }

  function checkInstallApp(li) {
    function clearTimers() {
      clearInterval(check);
      clearTimeout(timer);
    }

    function isHideWeb() {
      //현재 변경 감지 안됨
      if (window.document.webkitHidden || window.document.hidden) {
        clearTimers();
      }
    }
    const check = setInterval(isHideWeb, 200);

    const timer = setTimeout(function () {
      redirectStore(li);
    }, 2000);
  }

  const handleInstallApp = (li) => {
    exeDeepLink();
    checkInstallApp(li);
  };

  useDidMountEffect(() => {
    if (modalMsg.msg) {
      setOpenModal(true);
    }
  }, [modalMsg]);
  return (
    <ListWrap>
      {openModal && (
        <Modal setOpenModal={setOpenModal}>
          <p>{modalMsg.type === "func" ? modalMsg.msg() : modalMsg.msg}</p>
        </Modal>
      )}
      {dataByCategory["mobility"] ? <h4>모빌리티</h4> : ""}

      <Ul>
        {dataByCategory &&
          data.count > 0 &&
          dataByCategory["mobility"]?.map((li, index) => (
            <li key={`mobility` + index}>
              <LogoWrap
                className="pointer"
                onClick={() => handleInstallApp(li)}
              >
                <img src={li.image} alt="" />
              </LogoWrap>
              <p>{li.title}</p>
            </li>
          ))}
      </Ul>
      {dataByCategory["traffic"] ? <h4>교통</h4> : ""}
      <Ul>
        {dataByCategory &&
          data.count > 0 &&
          dataByCategory["traffic"]?.map((li, index) => (
            <li key={`traffic` + index}>
              <LogoWrap
                className="pointer"
                onClick={() => handleInstallApp(li)}
              >
                <img src={li.image} alt="" />
              </LogoWrap>
              <p>{li.title}</p>
            </li>
          ))}
      </Ul>
      {dataByCategory["charge"] ? <h4>충전</h4> : ""}
      <Ul>
        {dataByCategory &&
          data.count > 0 &&
          dataByCategory["charge"]?.map((li, index) => (
            <li key={`charge` + index}>
              <LogoWrap
                className="pointer"
                onClick={() => handleInstallApp(li)}
              >
                <img src={li.image} alt="" />
              </LogoWrap>
              <p>{li.title}</p>
            </li>
          ))}
      </Ul>
    </ListWrap>
  );
};

export default AffiliateIconsAllList;

const ListWrap = styled.div`
  h4 {
    text-align: left;
    margin-top: 2rem;
  }
  ul {
    display: flex;
    flex-wrap: wrap;
  }
  li {
    margin-top: 1.9rem;
  }
  p {
    color: ${({ theme }) => theme.color.black};
    text-align: center;
    font-family: NanumSquareR;
    font-size: 1.4rem;
    font-weight: 700;
    line-height: normal;
    letter-spacing: -0.42px;
    margin-top: 0.9rem;
  }
`;
const LogoWrap = styled.div`
  height: 7.2rem;
  border-radius: 10px;
  background: ${({ theme }) => theme.color.white};
  box-shadow: 0px 4px 12px 0px rgba(0, 0, 0, 0.05);
  display: flex;
  justify-content: center;
  align-items: center;
`;

const Ul = styled.ul`
  li {
    width: 7.2rem;
    text-align: center;
    margin: 1rem 0.3rem 0 0.3rem;
  }

  img {
    max-width: 80%;
    height: auto;
    max-height: 70%;
  }
`;
